import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop.jsx";

import Home from "./components/Home.jsx";
import HomeTailwind from "./components/Home-tailwind.jsx";
import Navbar from "./components/common/Navbar.jsx";
import Marketplace from "./components/Market.jsx";
import Cart from "./components/Cart.jsx";
import OtherServicesPage from "./components/Services.jsx";
import School from "./components/School.jsx";
import Privacy from "./components/Privacy.jsx";

import { ClientLogin, ClientRegister } from "./components/forms/ClientForm.jsx";
import ClientProfile from "./components/forms/clientProfile.jsx";

import ProductList from "./components/dashboard/ProductsList.jsx";
// import UserCommands from "./components/dashboard/UserCommands";
import MyOrders from "./components/dashboard/MyOrders.jsx";
import { NewProductProvider } from "./contexts/NewProductContext.jsx";
import { ProductDetail } from "./components/Market.jsx";
import { CartProvider } from "./contexts/CartContext.jsx";
import OrderConfirmation from "./components/OrderConfirmation.jsx";
import UploadPaymentProof from "./components/UploadPaymentProof.jsx";
import OrderDetail from "./components/dashboard/OrderDetail.jsx";

const App = () => {
  return (
    <CartProvider>
      <NewProductProvider>
        <Router>
          <ScrollToTop />
          <Navbar />
          <Routes>
            {/* <Route path="/" element={<Marketplace />} /> */}
            <Route path="/" element={<Home />} />
            <Route path="/home-new" element={<HomeTailwind />} />
            <Route path="/home" element={<Home />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/market" element={<Marketplace />} />
            <Route path="/market/:id" element={<Marketplace />} />
            <Route path="/services" element={<OtherServicesPage />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/login" element={<ClientLogin />} />
            <Route path="/register" element={<ClientRegister />} />
            <Route path="/profile" element={<ClientProfile />} />
            {/* <Route path="/houses" element={<HouseList />} /> */}
            <Route path="/school" element={<School />} />
            <Route path="/products" element={<ProductList />} />
            {/* <Route path="/cars" element={<CarList />} /> */}
            <Route path="/order-confirmation" element={<OrderConfirmation />} />
            <Route path="/order/:orderId" element={<OrderDetail />} />
            <Route
              path="/upload-payment/:orderId"
              element={<UploadPaymentProof />}
            />
            <Route path="/my-orders" element={<MyOrders />} />
          </Routes>
        </Router>
      </NewProductProvider>
    </CartProvider>
  );
};

export default App;
